import Client from "./Client";
import User from "Class/User";
import { AnyObject } from "types";
import { isSuper, isSuperAdmin } from "Services/Auth";

const resource = "/users";

export default class UserService {
  public static async getUsers(
    page: number,
    size: number,
    search = "",
    companyId: number,
    adminId: number,
    onlyAdmins: boolean
  ): Promise<AnyObject> {
    let url = `${resource}?page=${page}&page_size=${size}`;
    if (search.trim().length > 0) url += `&search=${search}`;
    if (companyId) url += `&companyId=${companyId}`;
    if (adminId) url += `&adminId=${adminId}`;
    if (onlyAdmins) url += `&onlyAdmins=${onlyAdmins}`;
    const { data } = await Client.get(url);
    return data;
  }

  public static async getUser(id: number): Promise<User> {
    const { data } = await Client.get(`${resource}/${id}`);
    return new User(data.data);
  }

  public static async setUsers(id: number, total: number): Promise<AnyObject> {
    const { data } = await Client.put(`${resource}/${id}/users_number`, {
      total,
    });
    return data;
  }

  public static async getAdmins(): Promise<Array<AnyObject>> {
    const { data } = await Client.get(`${resource}/admins`);
    return data.data;
  }

  public static async getUserByEmail(email: string): Promise<AnyObject> {
    const { data } = await Client.get(`${resource}/search?email=${email}`);
    return data;
  }

  public static async createUser(user: User): Promise<AnyObject> {
    const { data } = await Client.post(`${resource}`, user.asJSON());
    return data;
  }

  public static async updateUser(user: User): Promise<AnyObject> {
    const { data } = await Client.put(`${resource}/${user.id}`, user.asJSON());
    if (isSuper() || (isSuperAdmin() && [1, 3, 4].includes(user.role.priority)))
      await Client.put(`${resource}/update_role`, {
        userId: user.id,
        role: user.role.priority,
      });
    return data;
  }

  public static async removeFromCampaign(
    campaignId: number,
    userId: number
  ): Promise<AnyObject> {
    const { data } = await Client.post(`${resource}/remove_from_campaign`, {
      campaignId: campaignId,
      userId: userId,
    });
    return data;
  }

  public static async blockUser(
    userId: number,
    blocked: boolean
  ): Promise<string> {
    if (blocked) {
      await Client.put(`${resource}/${userId}/unblock`);
      return "Usuario desbloqueado con exito";
    } else {
      await Client.put(`${resource}/${userId}/block`);
      return "Usuario bloqueado con exito";
    }
  }

  public static async deleteUser(userId: number): Promise<string> {
    const { data } = await Client.delete(`${resource}/${userId}`);
    return data.data.message;
  }
}
